<div class="container-fluid px-0 h-100" [ngClass]="appStarted ? '':''">
    <nri-app-menu *ngIf="appStarted"></nri-app-menu>  
    <!-- <app-chatbot *ngIf="appStarted && NRO ==='Y'"></app-chatbot> -->
    <!-- <app-error-modal *ngIf="appStarted"></app-error-modal> -->
    <nri-app-register (registerStatus)="appStatus($event)" *ngIf="!appStarted"></nri-app-register>
</div>

<div *ngIf="pan && ref" class="modal fade" id="appstatus" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="exampleModalLabel">Thank you for choosing SBI Securities</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
            You Can Download your {{pis ? 'PIS' : 'AOF'}} by clicking the below link.    
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" *ngIf="pis" (click)="downloadAOF(false,ref,pan)">Download PIS</button>
          <button type="button" class="btn btn-primary" *ngIf="!pis" (click)="downloadAOF(true,ref,pan)">Download AOF</button>
        </div>
      </div>
    </div>
  </div>

  <app-error-modal #errorComp></app-error-modal>